import { forwardRef } from 'react';

const Grid = forwardRef(function Grid({ className = '' }, ref) {
  return (
    <div ref={ref} className={className}>
      <svg className="w-full h-auto lg:hidden" viewBox="0 0 355 444" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 0.5H354.5V443.5H0.5V0.5Z" stroke="#F5F0E3"/>
        <path d="M0.5 0.5H354.5V443.5H0.5V0.5Z" stroke="black" strokeOpacity="0.2"/>
        <path d="M0.5 89L354.5 89" stroke="#F5F0E3"/>
        <path d="M0.5 89L354.5 89" stroke="black" strokeOpacity="0.2"/>
        <path d="M0.5 177.5L354.5 177.5" stroke="#F5F0E3"/>
        <path d="M0.5 177.5L354.5 177.5" stroke="black" strokeOpacity="0.2"/>
        <path d="M0.5 266L354.5 266" stroke="#F5F0E3"/>
        <path d="M0.5 266L354.5 266" stroke="black" strokeOpacity="0.2"/>
        <path d="M265.5 1.5L265.5 443.5" stroke="#F5F0E3"/>
        <path d="M265.5 1.5L265.5 443.5" stroke="black" strokeOpacity="0.2"/>
        <path d="M177.5 1.5L177.5 443.5" stroke="#F5F0E3"/>
        <path d="M177.5 1.5L177.5 443.5" stroke="black" strokeOpacity="0.2"/>
        <path d="M88.5 1.5L88.4999 443.5" stroke="#F5F0E3"/>
        <path d="M88.5 1.5L88.4999 443.5" stroke="black" strokeOpacity="0.2"/>
        <path d="M0.5 354.5L354.5 354.5" stroke="#F5F0E3"/>
        <path d="M0.5 354.5L354.5 354.5" stroke="black" strokeOpacity="0.2"/>
      </svg>
      <svg className="w-full h-auto hidden lg:block" viewBox="0 0 1161 626" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <rect width="1161" height="626" fill="url(#pattern0_10109_19281)"/>
        <defs>
          <pattern id="pattern0_10109_19281" patternUnits="userSpaceOnUse" patternTransform="matrix(89.3002 0 0 89.3002 0 0)" preserveAspectRatio="none" viewBox="0 0 96.75 96.75" width="1" height="1">
            <g id="pattern0_10109_19281_inner">
              <rect x="0.25" y="0.25" width="96.25" height="96.25" stroke="#C6C3B4" strokeWidth="0.5"/>
            </g>
          </pattern>
        </defs>
      </svg>
    </div>
  );
});

export default Grid;
